<ion-content fullscreen="true" scroll-x="true" scroll-y="true">
  <ion-button (click)="dismissModal()" class="modal-close-btn">Close</ion-button>
  <div class="swiper">
    <div class="swiper-wrapper">
      <!-- Slides -->
      <div class="swiper-slide" *ngFor="let photo of photoUris; let i = index">
        <div class="swiper-zoom-container">
          <img [src]="photo" [alt]="photos[i]?.caption || 'Site Image'" class="site-image-gallery touch-zoom" />
        </div>
      </div>
    </div>
    <!-- If we need pagination -->
    <div class="swiper-pagination"></div>

    <!-- If we need navigation buttons -->
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>

    <!-- If we need scrollbar -->
    <div class="swiper-scrollbar"></div>
  </div>
</ion-content>
